export class LoadLocationAutocompleteAction {
  static readonly type = '[LocationAutocomplete] LoadLocationAutocompleteAction';

  constructor(public addressText: string) {
  }
}
